import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import React, { useState } from "react";
import PbCodeInputProps from "./PbCodeInputProps.type";

const InputsContainer = styled.div({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
})

const DigitInput = styled.input(
  (props: { height?: string; width?: string }) => ({
    width: props.width ? props.width : "15px",
    height: props.width ? props.width : "20px",
    borderRadius: "8px",
    margin: "0 3px",
    padding: "6px",
    border: "solid 0.5px black",
    textAlign: "center"
  })
);

const PbCodeInput = ({ digits, onChange, onEnter, value, isNumeric }: PbCodeInputProps) => {
  const [internalValue, setInternalValue] = useState(value);

  const handleChange = (value: string, position: number) => {
    if (value && value.length > 1) {
      return;
    }

    if(isNumeric){
      const numRgx = /^[0-9]*$/;
      if(!numRgx.test(value)){
        return
      }
    }

    let newValue = internalValue;

    let valueArr = newValue.split("");

    valueArr[position] = value;

    setInternalValue(valueArr.join(""));

    onChange(valueArr.join(""));

    //last code digit
    if (position + 1 === digits) {
      return;
    }
    if (valueArr.join("").length - 1 < position) {
      document.getElementById(`code-input-${valueArr.join("").length}`).focus();
      return;
    }
    document.getElementById(`code-input-${position + 1}`).focus();
  };

  const handleCopy = async () => {
    await navigator.clipboard.readText()
    .then(text => {
      if(text.length > 6) {
        setInternalValue(text.substring(0, 6))
        onChange(text.substring(0, 6));
      } else {
        setInternalValue(text)
        onChange(text);
      }
      
    }).catch(err => {

    });
  }

  const generateInputs = () => {
    let parts = [];
    for (let i = 0; i < digits; i++) {
      parts.push(
        <DigitInput
          id={`code-input-${i}`}
          key={`code-input-${i}`}
          value={internalValue[i] ? internalValue[i] : ""}
          onChange={() => {}}
          onKeyDown={(e) => {
            if(e.key.toLocaleLowerCase() === "enter"){
              if(onEnter){
                onEnter()
              }
            }
            if(e.ctrlKey && e.key.toLocaleLowerCase() === "v"){
              handleCopy()
              return
            }
            if (e.key.length === 1) {
              handleChange(e.key, i);
            }
            if (e.key.toLocaleLowerCase() === "backspace") {
              if (i > 0) {
                handleChange("", i);
                handleChange("", i-1);
                document.getElementById(`code-input-${i - 1}`).focus();
              } else {
                handleChange("", i);
                document.getElementById(`code-input-${i}`).focus();
              }
            }
          }}
        />
      );
    }

    return parts;
  };

  return (
    <InputsContainer>
      {generateInputs()}
    </InputsContainer>
  );
};

export default PbCodeInput;
